<template>
    <div
        class="w-full max-w-[1000px] h-full min-h-28 flex flex-col justify-center bg-neutral-0 text-base tracking-normal rounded-b-xl" 
    >
        <div class="flex w-full space-x-2 py-2 pl-5 pr-3 border-y border-neutral-2">
            <input type="text" class="w-full bg-neutral-0" v-model="link" placeholder="https://www.example.com/file.pdf" />
            <button
                class="rounded-lg pl-3 pr-1 pt-1 flex text-primary-extra-dark justify-center items-center bg-primary hover:bg-secondary"
                @click.prevent="addLink"
            >
                <div class="flex justify-center items-center mt-1">
                    <RightArrowSVG 
                        stroke-color="#154B51"
                        stroke-width="1.5"
                    />
                </div>
            </button>
        </div>
        <div class="overflow-y-scroll w-full h-full bg-neutral-0">
            <div v-if="links.length > 0" class="w-full grid grid-cols-4 ">
                <LinkThumbnail 
                    v-for="link of links" 
                    :key="link" 
                    :link="link"
                    @remove="removeLink" 
                />
            </div>
            <div v-else
                class="flex h-full w-full justify-center items-center text-neutral-5 tracking-widest"
            >
                No Links Added
            </div>
        </div>
        <div class="flex w-full justify-center py-3 border-t bg-neutral-1 border-neutral-2 rounded-br-xl">
            <button @click.prevent="uploadLinks"
            class="rounded-lg px-2 py-1  flex space-x-1 text-primary-extra-dark justify-center items-center bg-primary hover:bg-secondary"
            >
                Upload
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue'
import LinkThumbnail from '@/components/base-components/LinkThumbnail.vue';
import RightArrowSVG from '../svg-components/RightArrowSVG.vue';
const emit = defineEmits(['upload-links'])

const link = ref(null)
const links = ref([])

function addLink() {
    links.value.push(
        {
            _id: link.value,
            title: null,
            size: null,
            iconURL: null,
            link: link.value,
            extension: `. ${link.value.split(".").slice(-1)}`
        }
    )
    link.value = null
}

function removeLink(attachmentId) {
    const attachmentIndex = links.value.findIndex((attachment) => attachment._id == attachmentId)
    if(attachmentIndex != -1) {
        links.value.splice(attachmentIndex, 1)
    }
}

function uploadLinks() {
    emit('upload-links', links.value)
}

</script>